import calculateMinMax from './calculate-min-max';

const getRangeValue = (rawQueryProp, rangeInterval, _min, _max) => {
  const { min, max } = calculateMinMax({ min: _min, max: _max }, rangeInterval);

  if (rawQueryProp) {
    const [queryParamMin, queryParamMax] = Array.isArray(rawQueryProp)
      ? rawQueryProp[0].split('-')
      : rawQueryProp.split('-');
    const updatedMinValue = Number(queryParamMin);
    const updatedMaxValue = Number(queryParamMax);

    return {
      min: Number.isNaN(min) ? updatedMinValue : min,
      max: Number.isNaN(max) ? updatedMaxValue : max,
      step: rangeInterval,
      maxValue: updatedMaxValue,
      minValue: updatedMinValue
    };
  }

  return {
    max,
    min,
    step: rangeInterval,
    maxValue: max,
    minValue: min
  };
};

export default getRangeValue;
